import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

/**
 * Personas de la empresa: ocupadas / tope, y la plataforma puede fijar un tope propio para ESTA
 * empresa (excepción: no cambia el plan ni a las demás empresas que lo tienen).
 */
interface Props {
  ocupadas: number;
  /** `null` = sin tope. */
  tope: number | null;
  onGuardar: (maxUsers: number) => Promise<void>;
}

export function TopeDePersonas({ ocupadas, tope, onGuardar }: Props) {
  const [editando, setEditando] = useState(false);
  const [valor, setValor] = useState(String(tope ?? ocupadas));
  const [guardando, setGuardando] = useState(false);
  const n = Number(valor);
  const valido = Number.isInteger(n) && n >= 1;

  async function guardar() {
    setGuardando(true);
    try {
      await onGuardar(n);
      setEditando(false);
    } catch {
      // quien llama ya avisó el error; el campo queda abierto para reintentar
    } finally {
      setGuardando(false);
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <span>
        Personas: <strong>{ocupadas}</strong> / <strong>{tope ?? 'sin tope'}</strong>
        {tope !== null && ocupadas >= tope ? ' (llegó al tope)' : ''}
      </span>
      {editando ? (
        <>
          <Input
            aria-label="Tope de personas"
            type="number"
            min={1}
            className="h-8 w-24"
            value={valor}
            onChange={(e) => setValor(e.target.value)}
          />
          <Button size="sm" onClick={guardar} disabled={!valido || guardando}>
            Guardar
          </Button>
          <Button size="sm" variant="ghost" onClick={() => setEditando(false)}>
            Cancelar
          </Button>
        </>
      ) : (
        <Button size="sm" variant="outline" onClick={() => setEditando(true)}>
          Cambiar tope
        </Button>
      )}
    </div>
  );
}
